/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoContextualTabsController {
    /** @ngInject */
    constructor($transitions, $state, $log) {
        this.$state = $state;
        this.$log = $log;
        this.$log.debug('Controller \'GmaoContextualTabs\' loaded');
        this.listenerUnregistrationHooks = [];
        this.listenerUnregistrationHooks.push($transitions.onSuccess({}, transition => {
            this.setActiveState(transition.to().name);
        }));
    }

    $onInit() {
        this.tabs = [];
        this.setActiveState(this.$state.current.name);
    }

    $onDestroy() {
        // Unregisters all listeners from the root scope, to avoid multi-calls when the component will be loaded again.
        for (const listenerUnregistrationHook of this.listenerUnregistrationHooks) {
            listenerUnregistrationHook();
        }
    }

    setActiveState(state) {
        this.tabs.splice(0);

        switch (state) {
        case 'gmao.alarm.source.create':
        case 'gmao.alarm.source.list':
        case 'gmao.alarm.source.update':
        case 'gmao.alarm.code.create':
        case 'gmao.alarm.code.list':
        case 'gmao.alarm.code.update':
        case 'gmao.alarm.type.create':
        case 'gmao.alarm.type.list':
        case 'gmao.alarm.type.update':
        case 'gmao.organization.account.create':
        case 'gmao.organization.account.list':
        case 'gmao.organization.account.update':
        case 'gmao.organization.cause.create':
        case 'gmao.organization.cause.list':
        case 'gmao.organization.cause.update':
        case 'gmao.organization.company.create':
        case 'gmao.organization.company.list':
        case 'gmao.organization.company.update':
        case 'gmao.organization.grt.create':
        case 'gmao.organization.grt.list':
        case 'gmao.organization.grt.update':
        case 'gmao.organization.grtpolicy.edit':
        case 'gmao.organization.grtpolicy.list':
        case 'gmao.organization.site.create':
        case 'gmao.organization.site.list':
        case 'gmao.organization.site.update':
        case 'gmao.preventivesheet.template.create':
        case 'gmao.preventivesheet.template.list':
        case 'gmao.preventivesheet.template.update':
        case 'gmao.equipment.template.create':
        case 'gmao.equipment.template.list':
        case 'gmao.equipment.template.update':
            this.tabs.push({
                title: 'ui.equipmenttemplate.list',
                state: 'gmao.equipment.template.list'
            }, {
                title: 'ui.preventivesheettemplate.list',
                state: 'gmao.preventivesheet.template.list'
            }, {
                title: 'ui.grtpolicy.grtpolicy',
                state: 'gmao.organization.grtpolicy.list'
            }, {
                title: 'ui.grt.grt',
                state: 'gmao.organization.grt.list'
            }, {
                title: 'ui.alarmcode.list',
                state: 'gmao.alarm.code.list'
            }, {
                title: 'ui.alarmtype.list',
                state: 'gmao.alarm.type.list'
            }, {
                title: 'ui.alarmsource.list',
                state: 'gmao.alarm.source.list'
            }, {
                title: 'ui.cause.list',
                state: 'gmao.organization.cause.list'
            }, {
                title: 'ui.site.list',
                state: 'gmao.organization.site.list'
            }, {
                title: 'ui.account.list',
                state: 'gmao.organization.account.list'
            }, {
                title: 'ui.company.list',
                state: 'gmao.organization.company.list'
            });
            break;
        case 'gmao.alarm.create':
        case 'gmao.alarm.list':
        case 'gmao.alarm.update':
            this.tabs.push({
                title: 'ui.alarm.list',
                state: 'gmao.alarm.list'
            });
            break;
        case 'gmao.actionrequest.create':
        case 'gmao.actionrequest.list':
        case 'gmao.actionrequest.update':
            this.tabs.push({
                title: 'ui.actionrequest.list',
                state: 'gmao.actionrequest.list'
            },
            {
                title: 'ui.actionrequestprogmes.list',
                state: 'gmao.actionrequestprogmes.list'
            });
            break;
        case 'gmao.actionrequestprogmes.create':
        case 'gmao.actionrequestprogmes.list':
        case 'gmao.actionrequestprogmes.update':
            this.tabs.push({
                    title: 'ui.actionrequest.list',
                    state: 'gmao.actionrequest.list'
                },
                {
                    title: 'ui.actionrequestprogmes.list',
                    state: 'gmao.actionrequestprogmes.list'
                });
            break;
        case 'gmao.equipment.create':
        case 'gmao.equipment.list':
        case 'gmao.equipment.update':
            this.tabs.push({
                title: 'ui.equipment.list',
                state: 'gmao.equipment.list'
            });
            break;
        case 'gmao.preventivesheet.planning':
        case 'gmao.preventivesheet.create':
        case 'gmao.preventivesheet.list':
        case 'gmao.preventivesheet.update':
            case 'gmao.preventivesheet.importsexports':
            this.tabs.push({
                title: 'ui.preventiveplanning',
                state: 'gmao.preventivesheet.planning'
            }, {
                title: 'ui.preventivesheet.list',
                state: 'gmao.preventivesheet.list'
            }, {
                title: 'ui.preventivesheet.importsexports',
                state: 'gmao.preventivesheet.importsexports'
            });
            break;
        case 'gmao.statistics.board':
        case 'gmao.exports.board':
            this.tabs.push({
                title: 'ui.statistics.board',
                state: 'gmao.statistics.board'
            }, {
                title: 'ui.exports.board',
                state: 'gmao.exports.board'
            });
            break;
        default:
            break;
        }
        this.selectedTab = state;
    }
}

export const gmaoContextualTabsComponent = {
    template: require('./gmao-contextual-tabs.html'),
    controller: GmaoContextualTabsController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoContextualTabs.js